export var IdIconBuildingContext;
(function (IdIconBuildingContext) {
    IdIconBuildingContext["QuestsTaskRequirement"] = "QuestsTaskRequirement";
    IdIconBuildingContext["BuildItem"] = "BuildItem";
    IdIconBuildingContext["BuildDetail"] = "BuildDetail";
    IdIconBuildingContext["Adventure"] = "Adventure";
    IdIconBuildingContext["UpgradeOutskirtItem"] = "UpgradeOutskirtItem";
    IdIconBuildingContext["DemolishItem"] = "DemolishItem";
    IdIconBuildingContext["LevelUpReward"] = "LevelUpReward";
    IdIconBuildingContext["UpgradeBuildingItem"] = "UpgradeBuildingItem";
})(IdIconBuildingContext || (IdIconBuildingContext = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/icon-building/IdIconBuildingContext.ts
// module id = 230
// module chunks = 3